import { useId } from "react";
import type { SvgProps } from "components/icons/types";

// Two-point sparkle for the extraction "Review and confirm" banner. Pink→purple
// gradient is baked in (Figma node 944:17142), so it ignores currentColor by design —
// but it still accepts SvgProps (size/className) like every other icon. useId keeps the
// gradient id unique so two instances on one page don't collide.
export const ReviewSparkle = (props: SvgProps) => {
  const gradientId = useId();
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.8398 10.1055C13.4468 11.8187 14.5162 12.5492 16 12.9697C14.2844 13.4872 13.3312 14.1998 13.1396 16C12.4913 14.3177 11.5047 13.5258 10.0029 13.2461C11.6626 12.5793 12.3941 11.8407 12.8398 10.1055ZM6.69629 0C7.76703 3.84064 10.001 5.59022 13.1904 6.71875C9.35027 7.61464 7.15307 9.04463 6.45996 12.9648C5.29364 9.18621 3.25023 7.31145 0 6.48926C3.74012 5.25813 5.45565 3.74251 6.69629 0Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="6.45715"
          y1="2.04963"
          x2="16.8162"
          y2="21.0961"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E693BB" />
          <stop offset="0.405909" stopColor="#763EF3" />
          <stop offset="0.695572" stopColor="#6731F9" />
          <stop offset="1" stopColor="#4A23B2" />
        </linearGradient>
      </defs>
    </svg>
  );
};
